import React from 'react';
import styled from 'styled-components';
import { Link as RRLink } from 'react-router-dom';

const Wrapper = styled.header`
  grid-area: header;
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  background-color: var(--header-background);
  z-index: 15;
`;

const Nav = styled.nav`
  display: flex;
  height: var(--header-height);
  background-color: #fff;

  & > * {
    align-self: center;
  }
`;

const Logo = styled(RRLink)`
width: 352px;
img { width: 352px; }
@media (min-width: 768px) {
  width: 492px;
  img { width: 492px; }
}
`;

export const Header = () => {
  return (
    <Wrapper>
      <Nav className="container-fluid justify-content-center">
        <Logo className="mr-auto no-margin-print bigger-logo-print" to="/">
          <img alt="fairfax" src="https://storage.googleapis.com/futurefamily-images/payment-options/fairfax/logo.png" />
        </Logo>
      </Nav>
    </Wrapper>
  );
};

export default Header;
